// apiClient.js
import axios from 'axios';

//const API_URL = 'http://13.92.17.254:8080/';
const API_URL = 'https://askasper1.asper.revenuegrowth.ai/';
//const API_URL = 'https://fractal-mse-poc-mse-web-app01.azurewebsites.net/'
// Create axios instance
const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// No SSO: remove token interceptors. All requests are anonymous.

export default apiClient;
